'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Bullseye = require('./Bullseye.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Bullseye).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Bullseye/index.js
// module id = 1124
// module chunks = 1